import { useAppSelector } from "helpers/hooks";
import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { TAccountType, TAppContext } from "store/slices/auth-v2/auth-v2-model";
import { AdminLogoutRedirect, CandidateSurveyLogoutRedirect, EmployerLogoutRedirect, UnauthorizedRedirect } from "./AuthConstants";

export const AuthV2 = ({ appContext }: ({
    appContext: TAppContext
})) => {
    const { isAccountLoggedIn, accountAccess } = useAppSelector(state => state.auth.auth);
    const { postingSource } = useAppSelector((state) => state.candidate.applyJobHome);
    const location = useLocation();
    const currentPath = location.pathname + location.search;
    const [accountTypePath, setAccountTypePath] = useState<TAccountType | null>(null);
    const [currentPage, setCurrentPage] = useState<'assessment' | 'questionnaire' | string>('');

    // Update current path
    useEffect(() => {
        if (currentPath) {
            setAccountTypePath(currentPath.split('/')[1] as TAccountType ?? null)
            setCurrentPage(currentPath.split('/').pop() ?? '');
        }
    }, [currentPath]);

    if (isAccountLoggedIn && accountTypePath !== null) {
        switch (accountAccess?.role) {
            case 'employer':
            case 'hiring_manager':
            case 'owner':
            case 'observer':
            case 'recruiter':
                if (accountTypePath !== 'employer') {
                    return <Navigate to={UnauthorizedRedirect} />
                }
                break;
            case 'admin':
                if (accountTypePath !== 'admin') {
                    return <Navigate to={UnauthorizedRedirect} />
                }
                break;
            case 'candidate':
                if (accountTypePath !== 'candidate') {
                    return <Navigate to={UnauthorizedRedirect} />
                }
                break;
        }
    }

    const getRedirectAfterLogout = () => {
        switch (appContext) {
            case 'employer':
                return <Navigate to={EmployerLogoutRedirect} />;
            case 'admin':
                return <Navigate to={AdminLogoutRedirect} />;
            case 'candidate_apply_job':
                return <Navigate to={`${currentPath.replace('/' + currentPage, `${postingSource ? ('?ps=' + postingSource) : ''}`)}`} />;
            case 'candidate_survey':
                return <Navigate to={CandidateSurveyLogoutRedirect} />;
        }
    }

    return (<>
        {isAccountLoggedIn ? <Outlet /> : getRedirectAfterLogout()}
    </>)
}